<template>
  <article class="home-form">
    <section class="home-form__section">
      <fieldset class="home-form__fieldset">
        <input id="name" type="text" placeholder="Name" class="input" />
        <input id="email" type="email" placeholder="Email" class="input" />
        <input id="subject" type="text" placeholder="Subject" class="input" />
      </fieldset>

      <fieldset class="home-form__fieldset">
        <textarea id="message" placeholder="Message" class="input -textarea" />
      </fieldset>
    </section>

    <section class="home-form__section -button">
      <ActionButton>Envoyer</ActionButton>
    </section>
  </article>
</template>

<script>
export default {
  name: 'ComponentDemoContactForm'
}
</script>
